






import Vue from 'vue'
import MessagesTable from '@/components/MessagesTable.vue'
export default Vue.extend({
    name: 'MessagesFeed',
    components: { MessagesTable },
    data: () => ({
        feedFilters: [],
        toolbar: {
            title: 'Message History',
            left: [
                {
                    title: 'Back',
                    icon: 'mdi-chevron-left',
                    tooltip: 'Back',
                    permission: 0,
                    feature: null
                }
            ]
        }
    }),
    computed: {
        loading(): boolean {
            return this.$store.getters.messagesTableMessagesLoading
        }
    }
})
